export default __webpack_public_path__ + "static/media/download.456aace5.svg";